
import { defineComponent } from "vue";

export default defineComponent({
  name: "error-modal",
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
});
